<template>
  <div class="my_empty_tips">
    <template v-if="type === 'empty_tips'">
      <div
        class="file_empty flex_center_center flex_column"
        v-show="empty_tips_show"
      >
        <i class="empty_tips_img"></i>
        <div
          class="empty_tips_text"
          v-text="empty_tips_text"
        ></div>
        <el-button
          size="medium"
          type="primary"
          @click="handleClick('empty_tips')"
        >{{empty_tips_btn_name}}</el-button>
      </div>
    </template>
    <template v-if="type === 'tips'">
      <div
        class="https_tip w-100"
        v-show="tips_show"
      >
        <div class="show_https_tip d_inline_block cursor_p">
          <span v-text="tips_text"></span>
          <span
            :class="{underline:tipsTextSpec.underline}"
            @click="handleClick('tips')"
            :style="{color: tipsTextSpec.color}"
            v-text="tipsTextSpec.text"
          ></span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: 'my_empty_tips',
  props: {
    type: { // empty_tips | tips
      required: true,
      type: String
    },
    empty_tips_show: {
      type: Boolean,
      default: true
    },
    empty_tips_text: {
      type: String,
      default: i18n.t('components_my_empty_tips_index_2303')
    },
    empty_tips_btn_name: {
      type: String,
      default: i18n.t('components_my_empty_tips_index_2304')
    },
    tips_show: {
      type: Boolean,
      default: true
    },
    tips_text: {
      type: String,
      default: i18n.t('components_my_empty_tips_index_2305')
    },
    tips_text_spec: {
      type: Object,
      default: _ => { }
    }
  },
  data () {
    return {
      tipsTextSpec: {}
    }
  },
  watch: {
    tips_text_spec (v) {
      this.tipsTextSpec = Object.assign({
        color: '#f23a3a',
        underline: false, // 下划线
        text: i18n.t('components_my_empty_tips_index_2306')
      }, v)
    }
  },
  methods: {
    handleClick (type) {
      this.$emit('handleClick', type)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/commonly.scss";

.my_empty_tips {
  position: relative;
  .file_empty {
    padding: 90px 0;
    .empty_tips_img {
      display: block;
      width: 157px;
      height: 123px;
      margin: 0 auto 28px;
      background: url(~@/assets/image/default_icon.png) 0 0;
    }
    .empty_tips_text {
      margin-bottom: 28px;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .https_tip {
    position: absolute;
    height: auto;
    z-index: 900;
    .show_https_tip {
      //margin: 12px 0;
      padding: 8px 16px;
      background: #fffaee;
      border: 1px solid #f5e4b9;
      color: #333;
      width: auto;
      .underline {
        text-decoration: underline;
        text-decoration-line: underline;
        text-decoration-style: initial;
        text-decoration-color: initial;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/widgets/basic_plugin_code/components/empty_tips.vue